import BudgetCountyPracticeWorkspace from "components/Budget/BudgetCountyPracticeWorkspace";
import BudgetListWorkspace from "components/Budget/BudgetListWorkspace";
import BudgetMasterWorkspace from "components/Budget/BudgetMasterWorkspace";
import BudgetWorkspace from "components/Budget/BudgetWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";

export const budgetRoutes = [
  {
    path: "/budget",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
  {
    path: "/budget/:budget_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
  {
    path: "/budget/:budget_id/:budget_county_practice_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetCountyPracticeWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
  {
    path: "/budgets/farm_budgets",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
  // Keyed by mode: React Router would otherwise keep one instance, sort and selection included, across both screens.
  {
    path: "/budgets/budget_master",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetMasterWorkspace key="master" /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
  {
    path: "/budgets/costs",
    element: <RouteLayout />,
    children: [{ index: true, element: <BudgetMasterWorkspace key="costs" mode="costs" /> }],
    errorElement: <RouteErrorLayout errorTitle="Budget" />,
  },
];
